// UserProfile.js
import { connect } from 'react-redux';
import { goBack, replace } from 'redux-first-history';

import { SUBSCRIPTION_CURRENCY } from '../RemoteConfigKeys.js';

import Profile from '../page/Profile.jsx';

import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getShortLinkData from '../selector/getShortLinkData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';

import fetchUser from '../action/fetchUser.js';
import fetchUserIsFollowing from '../action/fetchUserIsFollowing.js';
import fetchUserIsBlocked from '../action/fetchUserIsBlocked.js';
import fetchShortLink from '../action/fetchShortLink.js';
import fetchUserSubscription from '../action/fetchUserSubscription.js';
import fetchDiamondPacks from '../action/fetchDiamondPacks.js';
import fetchUserFollowersTotalCount from '../action/fetchUserFollowersTotalCount.js';
import fetchUserFollowingTotalCount from '../action/fetchUserFollowingTotalCount.js';
import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import fetchFeedsTotalCount from '../action/fetchFeedsTotalCount.js';
import addModal from '../action/addModal.js';
import toggleModal from '../action/toggleModal.js';
import subscribeOnlineStatus from '../action/subscribeOnlineStatus.js';

import getShareLink from '../resource/getShareLink.js';
import {
  ProfileListType,
  PROFILE_FEED_REMOTE_CONFIG_KEY_MAP,
} from '../resource/profileConstants.js';
import { getSortedQueries } from '../resource/feedUtils.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

const mapStateToProps = (state, { userId, listType }) => {
  const postBaseFeedName = getFeedName(
    state,
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[ProfileListType.POST],
    '{USER_ID}',
    userId
  );
  const {
    intersectedFeedName: postIntersectedFeedName,
    filters: postFilters,
    sorts: postSorts,
  } = getSelectedQueryOptionObject(state, postBaseFeedName);
  const feedNameRemoteConfigKey = PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[listType];
  const outboxFeedName = getFeedName(
    state,
    feedNameRemoteConfigKey,
    '{USER_ID}',
    userId
  );

  const { intersectedFeedName, filters, sorts } = getSelectedQueryOptionObject(
    state,
    outboxFeedName,
    getSelectedFeedQueryOptions(state, feedNameRemoteConfigKey, undefined),
    getRemoteConfigData(
      state,
      `${feedNameRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
    )?.[0]
  );
  const listSelectPath = [
    'home',
    getReturnType({ feedName: intersectedFeedName }),
    intersectedFeedName,
  ];
  if (filters.length || sorts.length) {
    listSelectPath.push(
      getSortedQueries({
        filters,
        sorts,
      }).join('&')
    );
  }
  const shareLink = getShareLink();
  return {
    intersectedFeedName,
    postIntersectedFeedName,
    listType,
    meId: getMeData(state, 'id'),
    userId,
    username: getUserData(state, userId, 'username'),
    biography: getUserData(state, userId, 'biography'),
    shareLink,
    shortShareLink: getShortLinkData(state, shareLink),
    defaultSubscriptionCurrency: getRemoteConfigData(
      state,
      SUBSCRIPTION_CURRENCY
    ),
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(
      state,
      userId,
      listType
    ),
    userDetailFetchStatus: getNetworkingSummary(state, ['user', userId]),
    isFirstPageFetched: getNetworkingData(
      state,
      [...listSelectPath, 1],
      'isFetched'
    ),
    isFirstPageFetching: getNetworkingData(
      state,
      [...listSelectPath, 1],
      'isFetching'
    ),
    isOnline: getUserData(state, userId, 'isOnline'),
    lastModifiedAtUnix: getUserData(state, userId, 'lastModifiedAtUnix'),
    filters,
    sorts,
    postFilters,
    postSorts,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    replace: ({ pathname }) => dispatch(replace(pathname)),
    fetchUser: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUser({ id: userId, httpProxyHeaders })),
    fetchUserIsFollowing: ({ userId }) =>
      dispatch(fetchUserIsFollowing({ userId })),
    fetchUserIsBlocked: ({ userId }) =>
      dispatch(fetchUserIsBlocked({ userId })),
    fetchShortLink: ({ location }) => dispatch(fetchShortLink({ location })),
    fetchDiamondPacks: ({ currency, shopId, type, productIds }) =>
      dispatch(fetchDiamondPacks({ currency, shopId, type, productIds })),
    fetchUserSubscription: ({ userId }) =>
      dispatch(fetchUserSubscription({ userId })),
    fetchUserFollowersTotalCount: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUserFollowersTotalCount({ userId, httpProxyHeaders })),
    fetchUserFollowingTotalCount: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUserFollowingTotalCount({ userId, httpProxyHeaders })),
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    fetchFeedsTotalCount: payload => dispatch(fetchFeedsTotalCount(payload)),
    addModal: ({ id }) =>
      dispatch(addModal({ id, transitionStatus: 'opening' })),
    toggleModal: ({ modalId, payload, isOpen }) =>
      dispatch(toggleModal({ modalId, payload, isOpen })),
    subscribeOnlineStatus: ({ userId, shouldRetry }) =>
      dispatch(subscribeOnlineStatus({ userId, shouldRetry })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
